<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">채팅 전송</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">전송 아티스트</label>
                <ArtistSelect
                  class="col-sm-10"
                  @memberChangeEvent="getArtistInfo"
                  :show-title="false"
                  :show-all-units="true"
                  :show-members="false"
                  :is-filter="false"
                />
              </div>

              <div>
                <div class="row">
                  <label class="col-sm-2 col-form-label">전송유저아이디</label>
                </div>
                <div class="row">
                  <div class="col-sm-1"></div>
                  <div class="col-sm-11">
                    <base-input placeholder="내용">
                      <textarea class="form-control" rows="30" v-model="userIds" />
                    </base-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">메시지</label>
              </div>
              <div class="row">
                <div class="col-sm-1">한국어</div>
                <div class="col-sm-3">
                  <base-input placeholder="한국어">
                    <textarea class="form-control" id="content" rows="30" v-model="message.ko" />
                  </base-input>
                </div>
                <div class="col-sm-1">영어</div>
                <div class="col-sm-3">
                  <base-input placeholder="영어">
                    <textarea class="form-control" id="content" rows="30" v-model="message.en" />
                  </base-input>
                </div>
                <div class="col-sm-1">일본어</div>
                <div class="col-sm-3">
                  <base-input placeholder="일본어">
                    <textarea class="form-control" id="content" rows="30" v-model="message.ja" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">푸시제목</label>
              </div>
              <div class="row">
                <div class="col-sm-1">한국어</div>
                <div class="col-sm-3">
                  <base-input placeholder="제목" v-model="notification.titles.ko">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <div class="col-sm-1">영어</div>
                <div class="col-sm-3">
                  <base-input placeholder="제목" v-model="notification.titles.en">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <div class="col-sm-1">일본어</div>
                <div class="col-sm-3">
                  <base-input placeholder="제목" v-model="notification.titles.ja">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">푸시내용</label>
              </div>
              <div class="row">
                <div class="col-sm-1">한국어</div>
                <div class="col-sm-3">
                  <base-input placeholder="내용" v-model="notification.bodies.ko">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <div class="col-sm-1">영어</div>
                <div class="col-sm-3">
                  <base-input placeholder="내용" v-model="notification.bodies.en">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <div class="col-sm-1">일본어</div>
                <div class="col-sm-3">
                  <base-input placeholder="내용" v-model="notification.bodies.ja">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
            </div>
            <!--            <div class="row">-->
            <!--              <label class="col-sm-2 col-form-label">예약전송시간</label>-->
            <!--              <div class="col-sm-4">-->
            <!--                <el-date-picker type="datetime" placeholder="예약전송시간" v-model="notificationTime">ㅇㅇ</el-date-picker>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="row">-->
            <!--              <label class="col-sm-2 col-form-label">반복여부</label>-->
            <!--              <div class="col-sm-4">-->
            <!--                <el-select class="select-primary" size="large" placeholder="반복선택" v-model="repeat.repeatId">-->
            <!--                  <el-option-->
            <!--                    v-for="option in repeat.options"-->
            <!--                    class="select-primary"-->
            <!--                    :value="option.value"-->
            <!--                    :label="option.label"-->
            <!--                    :key="option.label"-->
            <!--                  ></el-option>-->
            <!--                </el-select>-->
            <!--              </div>-->

            <!--              <label v-if="repeat.repeatId" class="col-sm-2 col-form-label">반복기간</label>-->
            <!--              <div v-if="repeat.repeatId" class="col-sm-4">-->
            <!--                <base-input>-->
            <!--                  <el-date-picker type="date" placeholder="반복종료" v-model="repeat.repeatEndDate"></el-date-picker>-->
            <!--                </base-input>-->
            <!--              </div>-->
            <!--            </div>-->
          </card>
          <base-button @click="sendMessage()" type="success">알림전송</base-button>
          <!--          <base-button @click="sendNotification(true)" type="success">예약전송</base-button>-->
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";
import { Toast } from "@/util/Toast";
import { showAPIErrorToast } from "../../util/ErrorUtils";
import ArtistSelect from "@/pages/Components/ArtistSelect";

export default {
  components: {
    Card,
    ArtistSelect,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      message: { ko: null, en: null, ja: null },
      userIds: null,
      unitId: null,
      notification: { titles: { ko: null, en: null, ja: null }, bodies: { ko: null, en: null, ja: null } },
      notificationTime: null,
      validUnitIds: [],
    };
  },

  async created() {
    const res = await this.$axios.get("/notification/adminFollowings");
    this.validUnitIds = res.data.data.map((item) => item.unitId);
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
    },
    async sendMessage() {
      if (!this.validUnitIds.includes(this.unitId)) {
        window.Toast.error("운영자가 해당 아티스트를 팔로우하지 않았습니다");
        return;
      }
      if (this.userIds === null) {
        window.Toast.error("유저아이디를 입력해주세요");
        return;
      }
      if (this.message.ko === null || this.message.en === null || this.message.ja === null) {
        window.Toast.error("모든 메시지를 입력해주세요");
        return;
      }
      if (this.notification.titles.ko === null || this.notification.titles.en === null || this.notification.titles.ja === null) {
        window.Toast.error("모든 알림 타이틀을 입력해주세요");
        return;
      }

      const param = {
        message: this.message,
        notification: this.notification,
        unitId: this.unitId,
        userIds: this.userIds,
      };

      try {
        await this.$axios.put(`/notification/customChatNotification`, param);
        Toast.success("알림이 전송되었습니다");
      } catch (e) {
        showAPIErrorToast(e);
      }
    },

    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped>
textarea#content {
  max-height: 300px;
}
.bootstrap-switch {
  margin: 6px;
}
</style>
